// FAQ accordion component
import { t } from '../../utils/i18n.js';

export class FAQ {
  constructor(container) {
    this.container = container;
    this.faqItems = [
      { key: 'install' },
      { key: 'compatibility' },
      { key: 'excelFormat' },
      { key: 'pricing' },
      { key: 'upgrade' },
      { key: 'support' },
      { key: 'cancel' }
    ];
    
    this.init();
  }

  init() {
    this.render();
  }

  render() {
    const html = this.faqItems.map((item, index) => {
      const question = t(`faq.items.${item.key}.question`);
      const answer = t(`faq.items.${item.key}.answer`);
      
      return `
        <div class="faq-item" data-index="${index}">
          <button class="faq-question" data-i18n="faq.items.${item.key}.question">
            ${question}
          </button>
          <div class="faq-answer" data-i18n="faq.items.${item.key}.answer">
            ${answer}
          </div>
        </div>
      `;
    }).join('');
    
    this.container.innerHTML = html;
    
    // Event listeners
    this.container.querySelectorAll('.faq-question').forEach(question => {
      question.addEventListener('click', () => {
        const item = question.closest('.faq-item');
        const isOpen = item.classList.contains('open');
        
        // Close all items
        this.container.querySelectorAll('.faq-item').forEach(i => {
          i.classList.remove('open');
        });
        
        // Open clicked item if it wasn't open
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    });
  }
}











